export default __webpack_public_path__ + "static/media/BrainBreak cards10.a0528911.png";